module.exports = __webpack_public_path__ + "img/transaksi.08bb1558.png";